import React from 'react';
import { findDOMNode } from 'react-dom';
import { isBrowser, isMobile } from "react-device-detect";
import { TweenMax, TimelineLite } from 'gsap';
import ScrollMagic from '../../plugins/ScrollMagic';
import globals from '../../globals';

export default {

    setVars(Services) {
        this.ServicesNode = findDOMNode(Services);
        this.blocks = {};
        for (let i = 0; i <= 2; i++) {
            this.blocks[i] = {
                tab: findDOMNode(Services.desktopTabs[i]),
                block: findDOMNode(Services.desktopBlocks[i]),
                mobile: findDOMNode(Services.mobileBlocks[i])
            };
        }
    },

    destroy(controller) {
        controller.destroy(true);
    },

    initialise(Services) {
        if (!Services.titleRef || !Services.subTitleRef || !Services.desktopTabs) {
            return;
        }

        this.setVars(Services);
        this.ServicesNode = findDOMNode(Services);

        let controller = new ScrollMagic.Controller(),
            tl = new TimelineLite(),
            itemsTl = new TimelineLite();

        if (isBrowser) {
            let activeMask = this.blocks[1].tab.getElementsByClassName('tab-mask'),
                activeContentMask = this.blocks[1].block.getElementsByClassName('mask');

            itemsTl.to(activeMask, 0.75, {height: 0, ease: Power4.easeInOut})
                .to(activeContentMask, 0.75, {width: 0, ease: Power4.easeInOut})
                .fromTo(this.blocks[0].tab, 0.5, {y: 100, opacity: 0}, {y: 0, opacity: 1}, 1)
                .fromTo(this.blocks[2].tab, 0.5, {y: 100, opacity: 0}, {y: 0, opacity: 1}, 1);

            tl.fromTo(Services.titleRef , 0.75, {x: -100, opacity: 0}, {x: 0, opacity: 1, ease: Power4.easeOut})
                .fromTo(Services.subTitleRef , 1, globals.getSubAnimation(Services.subTitleRef), {backgroundPositionY: "0px", ease: Elastic.easeOut.config(1, 0.4)}, 0);

            new ScrollMagic.Scene({
                triggerElement: '.services-trigger',
                reverse: false
            })
                .setTween(tl)
                .addTo(controller);
        }

        if (isMobile) {
            itemsTl.add(() => {
                //this.switchTab(Services, 0);
            });
        }

        new ScrollMagic.Scene({
            triggerElement: '.services-trigger2',
            reverse: false
        })
            .setTween(itemsTl)
            .addTo(controller);

        return controller;
    },
    
    switchTab(Services, key) {
        this.setVars(Services);
        let selected = this.blocks[key];

        if (isBrowser) {
            let tl = new TimelineLite(),
                activeStates = [...this.ServicesNode.getElementsByClassName('active')];

            activeStates.map((item) => {
                item.classList.remove('active');
            });

            selected.tab.classList.add('active');
            selected.block.classList.add('active');

            tl.fromTo(selected.tab.getElementsByClassName('tab-mask'), 0.5, {height: "50%"}, {height: 0, ease: Power4.easeInOut})
                .fromTo(selected.block.getElementsByClassName('mask'), 0.5, {width: "50%"}, {width: 0, ease: Power4.easeInOut}, 0.15);
        }

        if (isMobile) {
            let tl = new TimelineLite(),
                tab = selected.mobile.getElementsByClassName('tab')[0],
                content = selected.mobile.getElementsByClassName('tab-content')[0];

            if (tab.classList.contains('active')) {
                tl.to(content, 0.2, {height: 0})
                    .add(() => {
                        content.classList.remove('active');
                        tab.classList.remove('active');
                    });
            } else {
                tl.add(() => {
                    content.classList.add('active');
                    tab.classList.add('active');
                })
                    .set(content, {height: 'auto'})
                    .from(content, 0.5, {height: 0});

            }
        }
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/homepage/Services/animations.js